import { render } from "./VerificarSMS.vue?vue&type=template&id=247ef98d&scoped=true"
import script from "./VerificarSMS.vue?vue&type=script&lang=js"
export * from "./VerificarSMS.vue?vue&type=script&lang=js"

import "./VerificarSMS.vue?vue&type=style&index=0&id=247ef98d&scoped=true&lang=css"

import exportComponent from "/var/www/html/lr-courses/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-247ef98d"]])

export default __exports__